export enum BillEntryMethod {
  Allocated = 'Allocated',
  Automatic = 'Automatic',
  Imported = 'Imported',
  Manual = 'Manual',
  Transferred = 'Transferred',
}
